export function unreachable(message: string): never {
  throw new Error(`Unreachable: ${message}`);
}

export function compileTimeUnreachable(value: never): never {
  throw new Error(`Unreachable point reached. Value expected to be of type never, got: ${value}`);
}
